import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { smartProfileApi } from '~/api/smartProfile';
import { CreatorGender } from '~/clientApi/creator.model';
import { ILocation } from '~/screens/MyAgency/components/SearchLocation';

export type SmartProfileFieldStatus = 'done' | 'pending';
type SmartProfileFieldType<ValType = string> = {
  status: SmartProfileFieldStatus;
  value: ValType;
};
export interface SmartProfileInformationResponse {
  id: string;
  firstName: SmartProfileFieldType;
  lastName: SmartProfileFieldType;
  location: SmartProfileFieldType<ILocation>;
  gender: SmartProfileFieldType<CreatorGender>;
  dateOfBirth: SmartProfileFieldType;
  bio: SmartProfileFieldType;
  verticals: SmartProfileFieldType;
}
const retryDelay = 2000;

export const areAllFieldsDone = (
  data: SmartProfileInformationResponse,
): boolean => {
  const { id: _, ...fieldsWithStatus } = data;
  return Object.values(fieldsWithStatus).every(
    (field) => field.status === 'done',
  );
};

// whalar-mode flow also make use of this hook
// please be aware in case any changes are done
export const useGetSmartProfileInformationFromRequestId = (
  aiRequestId?: string,
  options?: UseQueryOptions<
    SmartProfileInformationResponse,
    AxiosError<{ detail: string }>
  >,
) => {
  return useQuery<SmartProfileInformationResponse>(
    ['talent-profile-smart_profile', { aiRequestId }],
    () =>
      smartProfileApi
        .get(`/smart-profiles/profile-information/${aiRequestId}`)
        .then(({ data }) => {
          return data;
        }),
    {
      enabled: !!aiRequestId,
      refetchInterval: (data, query) => {
        if (query.state.error) {
          return false;
        }
        return data && areAllFieldsDone(data) ? false : retryDelay;
      },
      ...options,
    },
  );
};
